import { Property, SelectInput } from '@/components/form/fields/select/SelectInput';
import { cn } from '@/lib/utils';
import { Product } from '@/services/api/contracts/catalog/types';
import { DEFAULT_DEVICE_FEE_NAME } from '@/services/catalogue/useDeviceFee';
import { useDeviceFees } from '@/services/catalogue/useDeviceFees';
import { usePoSelectDeviceFee, usePoSelectedDeviceFee } from '@/services/purchaseOrders/usePurchaseOrderService';
import { FunctionComponent, useMemo } from 'react';
import { PurchaseOrderConfirmOrderDeviceFeeTable } from './PurchaseOrderConfirmOrderDeviceFeeTable';

interface PurchaseOrderConfirmOrderDeviceFeeSectionProps {
  devices: Product[];
}

const PurchaseOrderConfirmOrderDeviceFeeSection: FunctionComponent<PurchaseOrderConfirmOrderDeviceFeeSectionProps> = ({
  devices
}) => {
  const deviceFees = useDeviceFees();

  const selectedDeviceFee = usePoSelectedDeviceFee();
  const selectDeviceFee = usePoSelectDeviceFee();

  const options: Property[] = useMemo(() => {
    return [
      ...deviceFees.map(m => {
        return {
          name: m.name,
          id: m.id
        };
      })
    ].sort((a, b) => {
      // If both names are the target, keep order
      if (a.name === DEFAULT_DEVICE_FEE_NAME && b.name === DEFAULT_DEVICE_FEE_NAME) return 0;
      // If only a is the target, move it down
      if (a.name === DEFAULT_DEVICE_FEE_NAME) return 1;
      // If only b is the target, move it down
      if (b.name === DEFAULT_DEVICE_FEE_NAME) return -1;
      // Otherwise, sort alphabetically
      return a.name.localeCompare(b.name);
    });
  }, [deviceFees]);

  const onChange = (value: Property | null) => {
    if (value) {
      selectDeviceFee(value.id);
    }
  };

  const selectedOption = options.find(o => o.id === selectedDeviceFee?.id) ?? null;

  return (
    <div className="space-y-2 !mt-7">
      <div className="flex items-center justify-end space-x-5 mr-[4.4rem]">
        <span className="text-2xl font-bold">Device Fees</span>
        <SelectInput
          className={cn('w-[300px]', `${!selectedOption && 'border-dashed	border-red-500 border rounded-md'}`)}
          id={'deviceFeeSelect'}
          placeholder="Please Select"
          options={options}
          value={selectedOption}
          onChange={onChange}
        />
      </div>
      {selectedDeviceFee && <PurchaseOrderConfirmOrderDeviceFeeTable products={devices} />}
    </div>
  );
};

export default PurchaseOrderConfirmOrderDeviceFeeSection;
